import { jsx as C, jsxs as oe, Fragment as Te } from "react/jsx-runtime";
import ot, { createContext as At, useContext as me, useReducer as Cr, useMemo as Jt, useRef as Ar, useDebugValue as Ot, createElement as Tr, useEffect as Be, Component as Rr, useState as Nt, useCallback as _r } from "react";
import { initReactI18next as br, useTranslation as Se, Trans as It, I18nextProvider as wr } from "react-i18next";
import { useQueryClient as er, useQuery as Pr } from "@tanstack/react-query";
import { personalizedCardArtCacheKey as xr, usePersonalizedCardArtQuery as Or } from "@syf-api-library/personalized-card-art";
import { createInstance as Nr } from "i18next";
import Ir from "i18next-browser-languagedetector";
import Re from "syf-component-library/const/mediaQueries";
import { spacing as fe, fontWeights as Ie, fontSizes as ye, colors as tr, lineHeights as Dt } from "syf-component-library/defaultTheme";
import Tt from "syf-component-library/ui/typography/Body";
import { SlideInModalPortal as Dr, ModalHeader as Mr } from "syf-component-library/ui/patterns/SlideInModalPortal";
import { useAccountSummaryV2Query as kr } from "@syf-api-library/account-summary";
import { useProfileScopeQuery as Lr, useProfileQuery as $r } from "@syf-api-library/profile";
import { ModalFooter as Ur } from "syf-component-library/ui/patterns/SlideInModal";
import { Stack as et } from "syf-component-library/ui/spacing";
import { HTTPError as Fr } from "syf-js-utilities";
import { SyfLoader as zr } from "syf-component-library/ui";
const De = At({
  selectedAccountId: "",
  triggerAnalyticsEvent: () => {
  },
  authenticationRedirect: () => null,
  envProp: "development"
}), at = () => me(De), Yr = { BuildVersion: "1.2.0" }, W = { CUSTOM_CARD: "custom card" }, Y = { CUSTOM_CARD: "custom card" }, ue = {
  EXIT: "exit",
  GUIDELINE: "guideline",
  INSTRUCTIONS: "instructions",
  PLACE_ORDER: "place order",
  RESET: "reset",
  STATUSES: "statuses"
}, X = {
  APPROVED: "approved",
  COMPLETE: "complete",
  CONFIRMATION: "confirmation",
  CARD_SENT: "card sent",
  EDITOR: "editor",
  ERROR: "error",
  PENDING: "pending",
  PREVIEW: "preview",
  REJECTED: "rejected",
  START: "start",
  TECHNICAL_ERROR: "technical error",
  VIEW: "view"
}, Ne = {
  APPROVED: "card sent for approval",
  CARD_SENT: "card is on it's way",
  CHANGES_UNDONE: "Any changes will be undone",
  IMAGE_FILL_CONTAINER: "Image must fill container",
  LOSE_ALL_PROGRESS: "You'll lose all progress",
  REJECTED: "card has been rejected",
  SENT_FOR_APPROVAL: "Your custom artwork is being sent for approval!"
}, ke = {
  API_FAILURE: "api failure",
  EXIT_CONFIRMATION: "Exit confirmation",
  IMAGE_RESET_CONFIRMATION: "Image reset confirmation",
  VALIDATION_FAILURE: "validation failure"
}, Le = {
  EXIT_CONFIRMATION: "Are you sure you want to exit?",
  FILE_FORMAT_NOT_SUPPORTED: "image too large",
  IMAGE_RESET_CONFIRMATION: "Are you sure you want to reset your image?",
  IMAGE_TOO_LARGE: "image too large",
  IMAGE_TOO_SMALL: "image too small",
  TECHNICAL_ERROR: "experiencing technical difficulties"
}, Ae = "button", Ke = "close", jr = "cancel", Gr = "get started", Vr = "X", Br = "upload new image", Mt = {
  cardPrintingInProgress: {
    pageKind: W.CUSTOM_CARD,
    pageFunction: Y.CUSTOM_CARD,
    pageSubFunction: ue.STATUSES,
    pageName: X.APPROVED,
    message: Ne.APPROVED
  },
  cardSent: {
    pageKind: W.CUSTOM_CARD,
    pageFunction: Y.CUSTOM_CARD,
    pageSubFunction: ue.STATUSES,
    pageName: X.CARD_SENT,
    message: Ne.CARD_SENT
  },
  getStarted: {
    PageFunction: Y.CUSTOM_CARD,
    PageKind: W.CUSTOM_CARD,
    pageName: X.START
  },
  pending: {
    pageKind: W.CUSTOM_CARD,
    pageFunction: Y.CUSTOM_CARD,
    pageSubFunction: ue.STATUSES,
    pageName: X.PENDING
  },
  rejected: {
    pageKind: W.CUSTOM_CARD,
    pageFunction: Y.CUSTOM_CARD,
    pageSubFunction: ue.STATUSES,
    pageName: X.REJECTED,
    message: Ne.REJECTED
  }
}, Hr = {
  getStarted: ["manageCardArt"],
  manageCardArt: ["error"],
  pending: ["error"],
  cardPrintingInProgress: ["error"],
  cardSent: ["error"],
  rejected: ["getStarted", "error"],
  error: []
}, rr = {
  isModalOpen: !0
}, Kr = (e, r) => r.type === "TRANSITION" ? { ...e, activeScreen: r.payload } : r.type === "RESET" ? { ...e, activeScreen: void 0 } : e, nr = At({
  ...rr,
  handleModalClose: () => {
  },
  transition: () => {
  },
  reset: () => {
  }
}), Wr = ({ children: e, handleModalClose: r, isModalOpen: t }) => {
  const [n, i] = Cr(Kr, rr), { triggerAnalyticsEvent: s, selectedAccountId: c } = at(), u = er(), f = () => {
    i({ type: "RESET" });
  }, m = Jt(() => ({
    ...n,
    isModalOpen: t,
    handleModalClose: () => {
      f(), u.invalidateQueries(
        xr({
          accountId: c,
          accountIdType: "guid"
        })
      ), r();
    },
    transition: (g) => {
      if (!n.activeScreen || Hr[n.activeScreen].includes(g)) {
        i({ type: "TRANSITION", payload: g }), Mt[g] !== void 0 && s(Mt[g]);
        return;
      }
      console.error(`
          Invalid transition from ${n.activeScreen} to ${g}`);
    },
    reset: f
  }), [
    r,
    t,
    u,
    c,
    n,
    s
  ]);
  return /* @__PURE__ */ C(nr.Provider, { value: m, children: e });
}, _e = () => me(nr), Rt = At(void 0), Xr = Rt.Provider, it = () => {
  const e = me(Rt);
  if (!e)
    throw new Error("No config");
  return e;
}, qr = {
  title: {
    drawerTitle: "{{portfolioName}} Custom Card Art"
  },
  button: {
    closeButtonText: "Close",
    cancelButtonText: "Cancel",
    uploadNewImage: "Upload New Image",
    getStarted: "Get Started"
  },
  labels: {
    tryAgainText: "Please try again later.",
    customCardArtLoaderText: "One moment please"
  },
  headings: {
    technicalErrorTitle: "We are currently experiencing technical difficulties"
  },
  screen: {
    getStarted: {
      title: "Now you can customize your {{portfolioName}} credit card!",
      offeringDescription: "{{portfolioName}} is offering a new way to carry your best friend everywhere you go: a customized {{portfolioName}} credit card featuring a photo of your favorite pet!",
      processDescription: "Simply upload a photo of your pet, adjust it to fit the way you want, and submit your order for approval. Once approved, your new custom {{portfolioName}} credit card should arrive within 8 to 12 business days at no charge to you.",
      extraNoteDescription: "Note: You can only customize your card once, so make sure you love it before you submit your order.",
      customizeNowDescription: "Customize Now!"
    },
    cardPrintingInProgress: {
      title: "Your {{portfolioName}} credit card artwork has been approved!",
      primaryDescriptionText: "We’ve approved your artwork submission and are printing your new {{portfolioName}} credit card now. You should receive your new card in 8 to 12 business days."
    },
    pending: {
      title: "Your {{portfolioName}} credit card custom artwork is being sent for approval!",
      primaryDescriptionText: "You are all set. Once your card art is approved, we will get it in the mail for you. If approved, you should receive your new card in 8 to 12 business days."
    },
    rejected: {
      title: "Your {{portfolioName}} credit card custom artwork has been rejected.",
      primaryDescriptionText: "During review of your artwork submission for your {{portfolioName}} credit card, our team found inappropriate messages, images, or other content that is not allowed. If you attempt to resubmit new artwork, please refrain from uploading inappropriate, copy-written, or trademarked content."
    },
    cardSent: {
      title: "Your customized {{portfolioName}} credit card is on its way!",
      primaryDescriptionText: "We’ve printed and shipped your new {{portfolioName}} credit card. You should receive your new card within 8 to 12 business days."
    },
    common: {
      secondaryDescriptionText: "Until then, you can still use your current {{portfolioName}} credit card."
    }
  },
  subHeadings: {},
  helperNotes: {},
  errorText: {}
}, Qr = {
  title: {
    drawerTitle: "Personalización de Diseño de Arte de Tarjetas {{portfolioName}}"
  },
  button: {
    closeButtonText: "Cerrar",
    cancelButtonText: "Cancelar",
    uploadNewImage: "Cargar nueva imagen",
    getStarted: "Para comenzar"
  },
  labels: {
    tryAgainText: "Intente nuevamente más tarde.",
    customCardArtLoaderText: "Uno momento por favor"
  },
  headings: {
    technicalErrorTitle: "Actualmente, estamos experimentando dificultades técnicas"
  },
  screen: {
    getStarted: {
      title: "¡Ahora puede personalizar su tarjeta de crédito {{portfolioName}}!",
      offeringDescription: "{{portfolioName}} le ofrece una nueva forma de llevar a su mejor amigo a donde quiera que vaya: ¡una tarjeta de crédito {{portfolioName}} personalizada con una foto de su mascota favorita!",
      processDescription: "Simplemente, cargue una foto de su mascota, ajústela de la manera que desee y envíe su orden para su aprobación. Una vez aprobada, su nueva tarjeta de crédito {{portfolioName}} personalizada debería llegar dentro de 8 a 12 días hábiles sin costo para usted.",
      extraNoteDescription: "Nota: Solo puede personalizar su tarjeta una vez, así que asegúrese de que le guste antes de enviar su orden.",
      customizeNowDescription: "Personalizar Ahora!"
    },
    cardPrintingInProgress: {
      title: "¡El diseño de arte de su tarjeta de crédito {{portfolioName}} ha sido aprobado!",
      primaryDescriptionText: "Hemos aprobado su diseño de arte y ahora estamos imprimiendo su nueva tarjeta de crédito {{portfolioName}}. Debería recibir su nueva tarjeta dentro de 8 a 12 días hábiles."
    },
    pending: {
      title: "¡El diseño de arte personalizado de su tarjeta de crédito {{portfolioName}} se está enviando para su aprobación!",
      primaryDescriptionText: "Ya está todo listo. Una vez que se apruebe el diseño de arte de su tarjeta, se la enviaremos por correo postal. Si se aprueba, debería recibir su nueva tarjeta dentro de 8 a 12 días hábiles."
    },
    rejected: {
      title: "El diseño de arte personalizado de su tarjeta de crédito {{portfolioName}} ha sido rechazado.",
      primaryDescriptionText: "Durante la revisión del diseño de arte enviado para su tarjeta de crédito {{portfolioName}}, nuestro equipo encontró mensajes, imágenes u otro contenido inapropiado que no está permitido. Si intenta volver a enviar un nuevo diseño de arte, absténgase de cargar contenido inapropiado, con derechos de autor o marca registrada."
    },
    cardSent: {
      title: "¡Su tarjeta de crédito {{portfolioName}} personalizada está en camino!",
      primaryDescriptionText: "Hemos impreso y enviado su nueva tarjeta de crédito {{portfolioName}}. Debería recibir su nueva tarjeta dentro de 8 a 12 días hábiles."
    },
    common: {
      secondaryDescriptionText: "Hasta entonces, puede seguir usando su tarjeta de crédito {{portfolioName}} actual."
    }
  },
  subHeadings: {},
  helperNotes: {},
  errorText: {}
}, $e = "CustomCardArt", Zr = {
  en: {
    [$e]: qr
  },
  es: {
    [$e]: Qr
  }
}, pe = Nr({
  debug: !1,
  fallbackLng: "en",
  interpolation: { escapeValue: !1 },
  resources: Zr,
  defaultNS: $e
});
pe.use(new Ir(null, { lookupLocalStorage: "language" })).use(br).init();
const Jr = "assets/card-actions-mfe/technical-error.svg", en = "assets/card-actions-mfe/error-blocked.svg", tn = "assets/card-actions-mfe/thumbs-up.svg", or = "assets/card-actions-mfe/hands-greeting-high-five.svg", rn = "assets/card-actions-mfe/Pet-CardArt.svg", nn = "assets/card-actions-mfe/CareCredit-MasterCard-template.svg", on = "assets/card-actions-mfe/CareCredit-PrivateLabel-template.svg";
function an(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var mt = { exports: {} }, U = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kt;
function sn() {
  if (kt)
    return U;
  kt = 1;
  var e = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), c = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), R = Symbol.for("react.view_transition"), x = Symbol.for("react.client.reference");
  function y(o) {
    if (typeof o == "object" && o !== null) {
      var v = o.$$typeof;
      switch (v) {
        case e:
          switch (o = o.type, o) {
            case t:
            case i:
            case n:
            case f:
            case m:
            case R:
              return o;
            default:
              switch (o = o && o.$$typeof, o) {
                case c:
                case u:
                case A:
                case g:
                  return o;
                case s:
                  return o;
                default:
                  return v;
              }
          }
        case r:
          return v;
      }
    }
  }
  return U.ContextConsumer = s, U.ContextProvider = c, U.Element = e, U.ForwardRef = u, U.Fragment = t, U.Lazy = A, U.Memo = g, U.Portal = r, U.Profiler = i, U.StrictMode = n, U.Suspense = f, U.SuspenseList = m, U.isContextConsumer = function(o) {
    return y(o) === s;
  }, U.isContextProvider = function(o) {
    return y(o) === c;
  }, U.isElement = function(o) {
    return typeof o == "object" && o !== null && o.$$typeof === e;
  }, U.isForwardRef = function(o) {
    return y(o) === u;
  }, U.isFragment = function(o) {
    return y(o) === t;
  }, U.isLazy = function(o) {
    return y(o) === A;
  }, U.isMemo = function(o) {
    return y(o) === g;
  }, U.isPortal = function(o) {
    return y(o) === r;
  }, U.isProfiler = function(o) {
    return y(o) === i;
  }, U.isStrictMode = function(o) {
    return y(o) === n;
  }, U.isSuspense = function(o) {
    return y(o) === f;
  }, U.isSuspenseList = function(o) {
    return y(o) === m;
  }, U.isValidElementType = function(o) {
    return typeof o == "string" || typeof o == "function" || o === t || o === i || o === n || o === f || o === m || typeof o == "object" && o !== null && (o.$$typeof === A || o.$$typeof === g || o.$$typeof === c || o.$$typeof === s || o.$$typeof === u || o.$$typeof === x || o.getModuleId !== void 0);
  }, U.typeOf = y, U;
}
var F = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lt;
function cn() {
  return Lt || (Lt = 1, process.env.NODE_ENV !== "production" && function() {
    function e(o) {
      if (typeof o == "object" && o !== null) {
        var v = o.$$typeof;
        switch (v) {
          case r:
            switch (o = o.type, o) {
              case n:
              case s:
              case i:
              case m:
              case g:
              case x:
                return o;
              default:
                switch (o = o && o.$$typeof, o) {
                  case u:
                  case f:
                  case R:
                  case A:
                    return o;
                  case c:
                    return o;
                  default:
                    return v;
                }
            }
          case t:
            return v;
        }
      }
    }
    var r = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), c = Symbol.for("react.consumer"), u = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), A = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), x = Symbol.for("react.view_transition"), y = Symbol.for("react.client.reference");
    F.ContextConsumer = c, F.ContextProvider = u, F.Element = r, F.ForwardRef = f, F.Fragment = n, F.Lazy = R, F.Memo = A, F.Portal = t, F.Profiler = s, F.StrictMode = i, F.Suspense = m, F.SuspenseList = g, F.isContextConsumer = function(o) {
      return e(o) === c;
    }, F.isContextProvider = function(o) {
      return e(o) === u;
    }, F.isElement = function(o) {
      return typeof o == "object" && o !== null && o.$$typeof === r;
    }, F.isForwardRef = function(o) {
      return e(o) === f;
    }, F.isFragment = function(o) {
      return e(o) === n;
    }, F.isLazy = function(o) {
      return e(o) === R;
    }, F.isMemo = function(o) {
      return e(o) === A;
    }, F.isPortal = function(o) {
      return e(o) === t;
    }, F.isProfiler = function(o) {
      return e(o) === s;
    }, F.isStrictMode = function(o) {
      return e(o) === i;
    }, F.isSuspense = function(o) {
      return e(o) === m;
    }, F.isSuspenseList = function(o) {
      return e(o) === g;
    }, F.isValidElementType = function(o) {
      return typeof o == "string" || typeof o == "function" || o === n || o === s || o === i || o === m || o === g || typeof o == "object" && o !== null && (o.$$typeof === R || o.$$typeof === A || o.$$typeof === u || o.$$typeof === c || o.$$typeof === f || o.$$typeof === y || o.getModuleId !== void 0);
    }, F.typeOf = e;
  }()), F;
}
process.env.NODE_ENV === "production" ? mt.exports = sn() : mt.exports = cn();
var _t = mt.exports;
function ln(e) {
  function r(E, h, S, w, a) {
    for (var D = 0, p = 0, z = 0, M = 0, I, l, j = 0, B = 0, O, ee = O = I = 0, k = 0, Q = 0, je = 0, Z = 0, We = S.length, Ge = We - 1, de, b = "", G = "", lt = "", dt = "", Ee; k < We; ) {
      if (l = S.charCodeAt(k), k === Ge && p + M + z + D !== 0 && (p !== 0 && (l = p === 47 ? 10 : 47), M = z = D = 0, We++, Ge++), p + M + z + D === 0) {
        if (k === Ge && (0 < Q && (b = b.replace(R, "")), 0 < b.trim().length)) {
          switch (l) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              b += S.charAt(k);
          }
          l = 59;
        }
        switch (l) {
          case 123:
            for (b = b.trim(), I = b.charCodeAt(0), O = 1, Z = ++k; k < We; ) {
              switch (l = S.charCodeAt(k)) {
                case 123:
                  O++;
                  break;
                case 125:
                  O--;
                  break;
                case 47:
                  switch (l = S.charCodeAt(k + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (ee = k + 1; ee < Ge; ++ee)
                          switch (S.charCodeAt(ee)) {
                            case 47:
                              if (l === 42 && S.charCodeAt(ee - 1) === 42 && k + 2 !== ee) {
                                k = ee + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (l === 47) {
                                k = ee + 1;
                                break e;
                              }
                          }
                        k = ee;
                      }
                  }
                  break;
                case 91:
                  l++;
                case 40:
                  l++;
                case 34:
                case 39:
                  for (; k++ < Ge && S.charCodeAt(k) !== l; )
                    ;
              }
              if (O === 0)
                break;
              k++;
            }
            switch (O = S.substring(Z, k), I === 0 && (I = (b = b.replace(A, "").trim()).charCodeAt(0)), I) {
              case 64:
                switch (0 < Q && (b = b.replace(R, "")), l = b.charCodeAt(1), l) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    Q = h;
                    break;
                  default:
                    Q = be;
                }
                if (O = r(h, Q, O, l, a + 1), Z = O.length, 0 < re && (Q = t(be, b, je), Ee = u(3, O, Q, h, ne, te, Z, l, a, w), b = Q.join(""), Ee !== void 0 && (Z = (O = Ee.trim()).length) === 0 && (l = 0, O = "")), 0 < Z)
                  switch (l) {
                    case 115:
                      b = b.replace(H, c);
                    case 100:
                    case 109:
                    case 45:
                      O = b + "{" + O + "}";
                      break;
                    case 107:
                      b = b.replace(_, "$1 $2"), O = b + "{" + O + "}", O = J === 1 || J === 2 && s("@" + O, 3) ? "@-webkit-" + O + "@" + O : "@" + O;
                      break;
                    default:
                      O = b + O, w === 112 && (O = (G += O, ""));
                  }
                else
                  O = "";
                break;
              default:
                O = r(h, t(h, b, je), O, w, a + 1);
            }
            lt += O, O = je = Q = ee = I = 0, b = "", l = S.charCodeAt(++k);
            break;
          case 125:
          case 59:
            if (b = (0 < Q ? b.replace(R, "") : b).trim(), 1 < (Z = b.length))
              switch (ee === 0 && (I = b.charCodeAt(0), I === 45 || 96 < I && 123 > I) && (Z = (b = b.replace(" ", ":")).length), 0 < re && (Ee = u(1, b, h, E, ne, te, G.length, w, a, w)) !== void 0 && (Z = (b = Ee.trim()).length) === 0 && (b = "\0\0"), I = b.charCodeAt(0), l = b.charCodeAt(1), I) {
                case 0:
                  break;
                case 64:
                  if (l === 105 || l === 99) {
                    dt += b + S.charAt(k);
                    break;
                  }
                default:
                  b.charCodeAt(Z - 1) !== 58 && (G += i(b, I, l, b.charCodeAt(2)));
              }
            je = Q = ee = I = 0, b = "", l = S.charCodeAt(++k);
        }
      }
      switch (l) {
        case 13:
        case 10:
          p === 47 ? p = 0 : 1 + I === 0 && w !== 107 && 0 < b.length && (Q = 1, b += "\0"), 0 < re * he && u(0, b, h, E, ne, te, G.length, w, a, w), te = 1, ne++;
          break;
        case 59:
        case 125:
          if (p + M + z + D === 0) {
            te++;
            break;
          }
        default:
          switch (te++, de = S.charAt(k), l) {
            case 9:
            case 32:
              if (M + D + p === 0)
                switch (j) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    de = "";
                    break;
                  default:
                    l !== 32 && (de = " ");
                }
              break;
            case 0:
              de = "\\0";
              break;
            case 12:
              de = "\\f";
              break;
            case 11:
              de = "\\v";
              break;
            case 38:
              M + p + D === 0 && (Q = je = 1, de = "\f" + de);
              break;
            case 108:
              if (M + p + D + ce === 0 && 0 < ee)
                switch (k - ee) {
                  case 2:
                    j === 112 && S.charCodeAt(k - 3) === 58 && (ce = j);
                  case 8:
                    B === 111 && (ce = B);
                }
              break;
            case 58:
              M + p + D === 0 && (ee = k);
              break;
            case 44:
              p + z + M + D === 0 && (Q = 1, de += "\r");
              break;
            case 34:
            case 39:
              p === 0 && (M = M === l ? 0 : M === 0 ? l : M);
              break;
            case 91:
              M + p + z === 0 && D++;
              break;
            case 93:
              M + p + z === 0 && D--;
              break;
            case 41:
              M + p + D === 0 && z--;
              break;
            case 40:
              if (M + p + D === 0) {
                if (I === 0)
                  switch (2 * j + 3 * B) {
                    case 533:
                      break;
                    default:
                      I = 1;
                  }
                z++;
              }
              break;
            case 64:
              p + z + M + D + ee + O === 0 && (O = 1);
              break;
            case 42:
            case 47:
              if (!(0 < M + D + z))
                switch (p) {
                  case 0:
                    switch (2 * l + 3 * S.charCodeAt(k + 1)) {
                      case 235:
                        p = 47;
                        break;
                      case 220:
                        Z = k, p = 42;
                    }
                    break;
                  case 42:
                    l === 47 && j === 42 && Z + 2 !== k && (S.charCodeAt(Z + 2) === 33 && (G += S.substring(Z, k + 1)), de = "", p = 0);
                }
          }
          p === 0 && (b += de);
      }
      B = j, j = l, k++;
    }
    if (Z = G.length, 0 < Z) {
      if (Q = h, 0 < re && (Ee = u(2, G, Q, E, ne, te, Z, w, a, w), Ee !== void 0 && (G = Ee).length === 0))
        return dt + G + lt;
      if (G = Q.join(",") + "{" + G + "}", J * ce !== 0) {
        switch (J !== 2 || s(G, 2) || (ce = 0), ce) {
          case 111:
            G = G.replace(T, ":-moz-$1") + G;
            break;
          case 112:
            G = G.replace(P, "::-webkit-input-$1") + G.replace(P, "::-moz-$1") + G.replace(P, ":-ms-input-$1") + G;
        }
        ce = 0;
      }
    }
    return dt + G + lt;
  }
  function t(E, h, S) {
    var w = h.trim().split(v);
    h = w;
    var a = w.length, D = E.length;
    switch (D) {
      case 0:
      case 1:
        var p = 0;
        for (E = D === 0 ? "" : E[0] + " "; p < a; ++p)
          h[p] = n(E, h[p], S).trim();
        break;
      default:
        var z = p = 0;
        for (h = []; p < a; ++p)
          for (var M = 0; M < D; ++M)
            h[z++] = n(E[M] + " ", w[p], S).trim();
    }
    return h;
  }
  function n(E, h, S) {
    var w = h.charCodeAt(0);
    switch (33 > w && (w = (h = h.trim()).charCodeAt(0)), w) {
      case 38:
        return h.replace(N, "$1" + E.trim());
      case 58:
        return E.trim() + h.replace(N, "$1" + E.trim());
      default:
        if (0 < 1 * S && 0 < h.indexOf("\f"))
          return h.replace(N, (E.charCodeAt(0) === 58 ? "" : "$1") + E.trim());
    }
    return E + h;
  }
  function i(E, h, S, w) {
    var a = E + ";", D = 2 * h + 3 * S + 4 * w;
    if (D === 944) {
      E = a.indexOf(":", 9) + 1;
      var p = a.substring(E, a.length - 1).trim();
      return p = a.substring(0, E).trim() + p + ";", J === 1 || J === 2 && s(p, 1) ? "-webkit-" + p + p : p;
    }
    if (J === 0 || J === 2 && !s(a, 1))
      return a;
    switch (D) {
      case 1015:
        return a.charCodeAt(10) === 97 ? "-webkit-" + a + a : a;
      case 951:
        return a.charCodeAt(3) === 116 ? "-webkit-" + a + a : a;
      case 963:
        return a.charCodeAt(5) === 110 ? "-webkit-" + a + a : a;
      case 1009:
        if (a.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (a.charCodeAt(8) === 45)
          return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11))
          return a.replace(ae, "$1-webkit-$2") + a;
        break;
      case 932:
        if (a.charCodeAt(4) === 45)
          switch (a.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
            case 115:
              return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
            case 98:
              return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
          }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (a.charCodeAt(8) !== 99)
          break;
        return p = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + p + "-webkit-" + a + "-ms-flex-pack" + p + a;
      case 1005:
        return y.test(a) ? a.replace(x, ":-webkit-") + a.replace(x, ":-moz-") + a : a;
      case 1e3:
        switch (p = a.substring(13).trim(), h = p.indexOf("-") + 1, p.charCodeAt(0) + p.charCodeAt(h)) {
          case 226:
            p = a.replace(d, "tb");
            break;
          case 232:
            p = a.replace(d, "tb-rl");
            break;
          case 220:
            p = a.replace(d, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + p + a;
      case 1017:
        if (a.indexOf("sticky", 9) === -1)
          break;
      case 975:
        switch (h = (a = E).length - 10, p = (a.charCodeAt(h) === 33 ? a.substring(0, h) : a).substring(E.indexOf(":", 7) + 1).trim(), D = p.charCodeAt(0) + (p.charCodeAt(7) | 0)) {
          case 203:
            if (111 > p.charCodeAt(8))
              break;
          case 115:
            a = a.replace(p, "-webkit-" + p) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(p, "-webkit-" + (102 < D ? "inline-" : "") + "box") + ";" + a.replace(p, "-webkit-" + p) + ";" + a.replace(p, "-ms-" + p + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (a.charCodeAt(5) === 45)
          switch (a.charCodeAt(6)) {
            case 105:
              return p = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + p + "-ms-flex-" + p + a;
            case 115:
              return "-webkit-" + a + "-ms-flex-item-" + a.replace(q, "") + a;
            default:
              return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(q, "") + a;
          }
        break;
      case 973:
      case 989:
        if (a.charCodeAt(3) !== 45 || a.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (le.test(E) === !0)
          return (p = E.substring(E.indexOf(":") + 1)).charCodeAt(0) === 115 ? i(E.replace("stretch", "fill-available"), h, S, w).replace(":fill-available", ":stretch") : a.replace(p, "-webkit-" + p) + a.replace(p, "-moz-" + p.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (a.charCodeAt(5) === 102 ? "-ms-" + a : "") + a, S + w === 211 && a.charCodeAt(13) === 105 && 0 < a.indexOf("transform", 10))
          return a.substring(0, a.indexOf(";", 27) + 1).replace(o, "$1-webkit-$2") + a;
    }
    return a;
  }
  function s(E, h) {
    var S = E.indexOf(h === 1 ? ":" : "{"), w = E.substring(0, h !== 3 ? S : 10);
    return S = E.substring(S + 1, E.length - 1), we(h !== 2 ? w : w.replace(K, "$1"), S, h);
  }
  function c(E, h) {
    var S = i(h, h.charCodeAt(0), h.charCodeAt(1), h.charCodeAt(2));
    return S !== h + ";" ? S.replace(se, " or ($1)").substring(4) : "(" + h + ")";
  }
  function u(E, h, S, w, a, D, p, z, M, I) {
    for (var l = 0, j = h, B; l < re; ++l)
      switch (B = ie[l].call(g, E, j, S, w, a, D, p, z, M, I)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          j = B;
      }
    if (j !== h)
      return j;
  }
  function f(E) {
    switch (E) {
      case void 0:
      case null:
        re = ie.length = 0;
        break;
      default:
        if (typeof E == "function")
          ie[re++] = E;
        else if (typeof E == "object")
          for (var h = 0, S = E.length; h < S; ++h)
            f(E[h]);
        else
          he = !!E | 0;
    }
    return f;
  }
  function m(E) {
    return E = E.prefix, E !== void 0 && (we = null, E ? typeof E != "function" ? J = 1 : (J = 2, we = E) : J = 0), m;
  }
  function g(E, h) {
    var S = E;
    if (33 > S.charCodeAt(0) && (S = S.trim()), Pe = S, S = [Pe], 0 < re) {
      var w = u(-1, h, S, S, ne, te, 0, 0, 0, 0);
      w !== void 0 && typeof w == "string" && (h = w);
    }
    var a = r(be, S, h, 0, 0);
    return 0 < re && (w = u(-2, a, S, S, ne, te, a.length, 0, 0, 0), w !== void 0 && (a = w)), Pe = "", ce = 0, te = ne = 1, a;
  }
  var A = /^\0+/g, R = /[\0\r\f]/g, x = /: */g, y = /zoo|gra/, o = /([,: ])(transform)/g, v = /,\r+?/g, N = /([\t\r\n ])*\f?&/g, _ = /@(k\w+)\s*(\S*)\s*/, P = /::(place)/g, T = /:(read-only)/g, d = /[svh]\w+-[tblr]{2}/, H = /\(\s*(.*)\s*\)/g, se = /([\s\S]*?);/g, q = /-self|flex-/g, K = /[^]*?(:[rp][el]a[\w-]+)[^]*/, le = /stretch|:\s*\w+\-(?:conte|avail)/, ae = /([^-])(image-set\()/, te = 1, ne = 1, ce = 0, J = 1, be = [], ie = [], re = 0, we = null, he = 0, Pe = "";
  return g.use = f, g.set = m, e !== void 0 && m(e), g;
}
var dn = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function un(e) {
  var r = {};
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var pn = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, $t = un(
  function(e) {
    return pn.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), ht = { exports: {} }, L = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ut;
function fn() {
  if (Ut)
    return L;
  Ut = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, g = e ? Symbol.for("react.forward_ref") : 60112, A = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, o = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, N = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function P(d) {
    if (typeof d == "object" && d !== null) {
      var H = d.$$typeof;
      switch (H) {
        case r:
          switch (d = d.type, d) {
            case f:
            case m:
            case n:
            case s:
            case i:
            case A:
              return d;
            default:
              switch (d = d && d.$$typeof, d) {
                case u:
                case g:
                case y:
                case x:
                case c:
                  return d;
                default:
                  return H;
              }
          }
        case t:
          return H;
      }
    }
  }
  function T(d) {
    return P(d) === m;
  }
  return L.AsyncMode = f, L.ConcurrentMode = m, L.ContextConsumer = u, L.ContextProvider = c, L.Element = r, L.ForwardRef = g, L.Fragment = n, L.Lazy = y, L.Memo = x, L.Portal = t, L.Profiler = s, L.StrictMode = i, L.Suspense = A, L.isAsyncMode = function(d) {
    return T(d) || P(d) === f;
  }, L.isConcurrentMode = T, L.isContextConsumer = function(d) {
    return P(d) === u;
  }, L.isContextProvider = function(d) {
    return P(d) === c;
  }, L.isElement = function(d) {
    return typeof d == "object" && d !== null && d.$$typeof === r;
  }, L.isForwardRef = function(d) {
    return P(d) === g;
  }, L.isFragment = function(d) {
    return P(d) === n;
  }, L.isLazy = function(d) {
    return P(d) === y;
  }, L.isMemo = function(d) {
    return P(d) === x;
  }, L.isPortal = function(d) {
    return P(d) === t;
  }, L.isProfiler = function(d) {
    return P(d) === s;
  }, L.isStrictMode = function(d) {
    return P(d) === i;
  }, L.isSuspense = function(d) {
    return P(d) === A;
  }, L.isValidElementType = function(d) {
    return typeof d == "string" || typeof d == "function" || d === n || d === m || d === s || d === i || d === A || d === R || typeof d == "object" && d !== null && (d.$$typeof === y || d.$$typeof === x || d.$$typeof === c || d.$$typeof === u || d.$$typeof === g || d.$$typeof === v || d.$$typeof === N || d.$$typeof === _ || d.$$typeof === o);
  }, L.typeOf = P, L;
}
var $ = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ft;
function mn() {
  return Ft || (Ft = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, g = e ? Symbol.for("react.forward_ref") : 60112, A = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, o = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, N = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function P(l) {
      return typeof l == "string" || typeof l == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      l === n || l === m || l === s || l === i || l === A || l === R || typeof l == "object" && l !== null && (l.$$typeof === y || l.$$typeof === x || l.$$typeof === c || l.$$typeof === u || l.$$typeof === g || l.$$typeof === v || l.$$typeof === N || l.$$typeof === _ || l.$$typeof === o);
    }
    function T(l) {
      if (typeof l == "object" && l !== null) {
        var j = l.$$typeof;
        switch (j) {
          case r:
            var B = l.type;
            switch (B) {
              case f:
              case m:
              case n:
              case s:
              case i:
              case A:
                return B;
              default:
                var O = B && B.$$typeof;
                switch (O) {
                  case u:
                  case g:
                  case y:
                  case x:
                  case c:
                    return O;
                  default:
                    return j;
                }
            }
          case t:
            return j;
        }
      }
    }
    var d = f, H = m, se = u, q = c, K = r, le = g, ae = n, te = y, ne = x, ce = t, J = s, be = i, ie = A, re = !1;
    function we(l) {
      return re || (re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), he(l) || T(l) === f;
    }
    function he(l) {
      return T(l) === m;
    }
    function Pe(l) {
      return T(l) === u;
    }
    function E(l) {
      return T(l) === c;
    }
    function h(l) {
      return typeof l == "object" && l !== null && l.$$typeof === r;
    }
    function S(l) {
      return T(l) === g;
    }
    function w(l) {
      return T(l) === n;
    }
    function a(l) {
      return T(l) === y;
    }
    function D(l) {
      return T(l) === x;
    }
    function p(l) {
      return T(l) === t;
    }
    function z(l) {
      return T(l) === s;
    }
    function M(l) {
      return T(l) === i;
    }
    function I(l) {
      return T(l) === A;
    }
    $.AsyncMode = d, $.ConcurrentMode = H, $.ContextConsumer = se, $.ContextProvider = q, $.Element = K, $.ForwardRef = le, $.Fragment = ae, $.Lazy = te, $.Memo = ne, $.Portal = ce, $.Profiler = J, $.StrictMode = be, $.Suspense = ie, $.isAsyncMode = we, $.isConcurrentMode = he, $.isContextConsumer = Pe, $.isContextProvider = E, $.isElement = h, $.isForwardRef = S, $.isFragment = w, $.isLazy = a, $.isMemo = D, $.isPortal = p, $.isProfiler = z, $.isStrictMode = M, $.isSuspense = I, $.isValidElementType = P, $.typeOf = T;
  }()), $;
}
process.env.NODE_ENV === "production" ? ht.exports = fn() : ht.exports = mn();
var hn = ht.exports, bt = hn, gn = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, yn = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Sn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, ar = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, wt = {};
wt[bt.ForwardRef] = Sn;
wt[bt.Memo] = ar;
function zt(e) {
  return bt.isMemo(e) ? ar : wt[e.$$typeof] || gn;
}
var En = Object.defineProperty, vn = Object.getOwnPropertyNames, Yt = Object.getOwnPropertySymbols, Cn = Object.getOwnPropertyDescriptor, An = Object.getPrototypeOf, jt = Object.prototype;
function ir(e, r, t) {
  if (typeof r != "string") {
    if (jt) {
      var n = An(r);
      n && n !== jt && ir(e, n, t);
    }
    var i = vn(r);
    Yt && (i = i.concat(Yt(r)));
    for (var s = zt(e), c = zt(r), u = 0; u < i.length; ++u) {
      var f = i[u];
      if (!yn[f] && !(t && t[f]) && !(c && c[f]) && !(s && s[f])) {
        var m = Cn(r, f);
        try {
          En(e, f, m);
        } catch {
        }
      }
    }
  }
  return e;
}
var Tn = ir;
const Rn = /* @__PURE__ */ an(Tn);
function ge() {
  return (ge = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }).apply(this, arguments);
}
var Gt = function(e, r) {
  for (var t = [e[0]], n = 0, i = r.length; n < i; n += 1)
    t.push(r[n], e[n + 1]);
  return t;
}, gt = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !_t.typeOf(e);
}, rt = Object.freeze([]), Ce = Object.freeze({});
function He(e) {
  return typeof e == "function";
}
function yt(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function Pt(e) {
  return e && typeof e.styledComponentId == "string";
}
var Ue = typeof process < "u" && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", xt = typeof window < "u" && "HTMLElement" in window, _n = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), bn = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
` } : {};
function wn() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], r = [], t = 1, n = arguments.length; t < n; t += 1)
    r.push(t < 0 || arguments.length <= t ? void 0 : arguments[t]);
  return r.forEach(function(i) {
    e = e.replace(/%[a-z]/, i);
  }), e;
}
function ze(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (t.length > 0 ? " Args: " + t.join(", ") : "")) : new Error(wn.apply(void 0, [bn[e]].concat(t)).trim());
}
var Pn = function() {
  function e(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  var r = e.prototype;
  return r.indexOfGroup = function(t) {
    for (var n = 0, i = 0; i < t; i++)
      n += this.groupSizes[i];
    return n;
  }, r.insertRules = function(t, n) {
    if (t >= this.groupSizes.length) {
      for (var i = this.groupSizes, s = i.length, c = s; t >= c; )
        (c <<= 1) < 0 && ze(16, "" + t);
      this.groupSizes = new Uint32Array(c), this.groupSizes.set(i), this.length = c;
      for (var u = s; u < c; u++)
        this.groupSizes[u] = 0;
    }
    for (var f = this.indexOfGroup(t + 1), m = 0, g = n.length; m < g; m++)
      this.tag.insertRule(f, n[m]) && (this.groupSizes[t]++, f++);
  }, r.clearGroup = function(t) {
    if (t < this.length) {
      var n = this.groupSizes[t], i = this.indexOfGroup(t), s = i + n;
      this.groupSizes[t] = 0;
      for (var c = i; c < s; c++)
        this.tag.deleteRule(i);
    }
  }, r.getGroup = function(t) {
    var n = "";
    if (t >= this.length || this.groupSizes[t] === 0)
      return n;
    for (var i = this.groupSizes[t], s = this.indexOfGroup(t), c = s + i, u = s; u < c; u++)
      n += this.tag.getRule(u) + `/*!sc*/
`;
    return n;
  }, e;
}(), tt = /* @__PURE__ */ new Map(), nt = /* @__PURE__ */ new Map(), Ve = 1, Xe = function(e) {
  if (tt.has(e))
    return tt.get(e);
  for (; nt.has(Ve); )
    Ve++;
  var r = Ve++;
  return process.env.NODE_ENV !== "production" && ((0 | r) < 0 || r > 1 << 30) && ze(16, "" + r), tt.set(e, r), nt.set(r, e), r;
}, xn = function(e) {
  return nt.get(e);
}, On = function(e, r) {
  r >= Ve && (Ve = r + 1), tt.set(e, r), nt.set(r, e);
}, Nn = "style[" + Ue + '][data-styled-version="5.3.3"]', In = new RegExp("^" + Ue + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Dn = function(e, r, t) {
  for (var n, i = t.split(","), s = 0, c = i.length; s < c; s++)
    (n = i[s]) && e.registerName(r, n);
}, Mn = function(e, r) {
  for (var t = (r.textContent || "").split(`/*!sc*/
`), n = [], i = 0, s = t.length; i < s; i++) {
    var c = t[i].trim();
    if (c) {
      var u = c.match(In);
      if (u) {
        var f = 0 | parseInt(u[1], 10), m = u[2];
        f !== 0 && (On(m, f), Dn(e, m, u[3]), e.getTag().insertRules(f, n)), n.length = 0;
      } else
        n.push(c);
    }
  }
}, kn = function() {
  return typeof window < "u" && window.__webpack_nonce__ !== void 0 ? window.__webpack_nonce__ : null;
}, sr = function(e) {
  var r = document.head, t = e || r, n = document.createElement("style"), i = function(u) {
    for (var f = u.childNodes, m = f.length; m >= 0; m--) {
      var g = f[m];
      if (g && g.nodeType === 1 && g.hasAttribute(Ue))
        return g;
    }
  }(t), s = i !== void 0 ? i.nextSibling : null;
  n.setAttribute(Ue, "active"), n.setAttribute("data-styled-version", "5.3.3");
  var c = kn();
  return c && n.setAttribute("nonce", c), t.insertBefore(n, s), n;
}, Ln = function() {
  function e(t) {
    var n = this.element = sr(t);
    n.appendChild(document.createTextNode("")), this.sheet = function(i) {
      if (i.sheet)
        return i.sheet;
      for (var s = document.styleSheets, c = 0, u = s.length; c < u; c++) {
        var f = s[c];
        if (f.ownerNode === i)
          return f;
      }
      ze(17);
    }(n), this.length = 0;
  }
  var r = e.prototype;
  return r.insertRule = function(t, n) {
    try {
      return this.sheet.insertRule(n, t), this.length++, !0;
    } catch {
      return !1;
    }
  }, r.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, r.getRule = function(t) {
    var n = this.sheet.cssRules[t];
    return n !== void 0 && typeof n.cssText == "string" ? n.cssText : "";
  }, e;
}(), $n = function() {
  function e(t) {
    var n = this.element = sr(t);
    this.nodes = n.childNodes, this.length = 0;
  }
  var r = e.prototype;
  return r.insertRule = function(t, n) {
    if (t <= this.length && t >= 0) {
      var i = document.createTextNode(n), s = this.nodes[t];
      return this.element.insertBefore(i, s || null), this.length++, !0;
    }
    return !1;
  }, r.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, r.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, e;
}(), Un = function() {
  function e(t) {
    this.rules = [], this.length = 0;
  }
  var r = e.prototype;
  return r.insertRule = function(t, n) {
    return t <= this.length && (this.rules.splice(t, 0, n), this.length++, !0);
  }, r.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, r.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, e;
}(), Vt = xt, Fn = { isServer: !xt, useCSSOMInjection: !_n }, cr = function() {
  function e(t, n, i) {
    t === void 0 && (t = Ce), n === void 0 && (n = {}), this.options = ge({}, Fn, {}, t), this.gs = n, this.names = new Map(i), this.server = !!t.isServer, !this.server && xt && Vt && (Vt = !1, function(s) {
      for (var c = document.querySelectorAll(Nn), u = 0, f = c.length; u < f; u++) {
        var m = c[u];
        m && m.getAttribute(Ue) !== "active" && (Mn(s, m), m.parentNode && m.parentNode.removeChild(m));
      }
    }(this));
  }
  e.registerId = function(t) {
    return Xe(t);
  };
  var r = e.prototype;
  return r.reconstructWithOptions = function(t, n) {
    return n === void 0 && (n = !0), new e(ge({}, this.options, {}, t), this.gs, n && this.names || void 0);
  }, r.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, r.getTag = function() {
    return this.tag || (this.tag = (i = (n = this.options).isServer, s = n.useCSSOMInjection, c = n.target, t = i ? new Un(c) : s ? new Ln(c) : new $n(c), new Pn(t)));
    var t, n, i, s, c;
  }, r.hasNameForId = function(t, n) {
    return this.names.has(t) && this.names.get(t).has(n);
  }, r.registerName = function(t, n) {
    if (Xe(t), this.names.has(t))
      this.names.get(t).add(n);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(n), this.names.set(t, i);
    }
  }, r.insertRules = function(t, n, i) {
    this.registerName(t, n), this.getTag().insertRules(Xe(t), i);
  }, r.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, r.clearRules = function(t) {
    this.getTag().clearGroup(Xe(t)), this.clearNames(t);
  }, r.clearTag = function() {
    this.tag = void 0;
  }, r.toString = function() {
    return function(t) {
      for (var n = t.getTag(), i = n.length, s = "", c = 0; c < i; c++) {
        var u = xn(c);
        if (u !== void 0) {
          var f = t.names.get(u), m = n.getGroup(c);
          if (f && m && f.size) {
            var g = Ue + ".g" + c + '[id="' + u + '"]', A = "";
            f !== void 0 && f.forEach(function(R) {
              R.length > 0 && (A += R + ",");
            }), s += "" + m + g + '{content:"' + A + `"}/*!sc*/
`;
          }
        }
      }
      return s;
    }(this);
  }, e;
}(), zn = /(a)(d)/gi, Bt = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function St(e) {
  var r, t = "";
  for (r = Math.abs(e); r > 52; r = r / 52 | 0)
    t = Bt(r % 52) + t;
  return (Bt(r % 52) + t).replace(zn, "$1-$2");
}
var xe = function(e, r) {
  for (var t = r.length; t; )
    e = 33 * e ^ r.charCodeAt(--t);
  return e;
}, lr = function(e) {
  return xe(5381, e);
};
function Yn(e) {
  for (var r = 0; r < e.length; r += 1) {
    var t = e[r];
    if (He(t) && !Pt(t))
      return !1;
  }
  return !0;
}
var jn = lr("5.3.3"), Gn = function() {
  function e(r, t, n) {
    this.rules = r, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (n === void 0 || n.isStatic) && Yn(r), this.componentId = t, this.baseHash = xe(jn, t), this.baseStyle = n, cr.registerId(t);
  }
  return e.prototype.generateAndInjectStyles = function(r, t, n) {
    var i = this.componentId, s = [];
    if (this.baseStyle && s.push(this.baseStyle.generateAndInjectStyles(r, t, n)), this.isStatic && !n.hash)
      if (this.staticRulesId && t.hasNameForId(i, this.staticRulesId))
        s.push(this.staticRulesId);
      else {
        var c = Fe(this.rules, r, t, n).join(""), u = St(xe(this.baseHash, c) >>> 0);
        if (!t.hasNameForId(i, u)) {
          var f = n(c, "." + u, void 0, i);
          t.insertRules(i, u, f);
        }
        s.push(u), this.staticRulesId = u;
      }
    else {
      for (var m = this.rules.length, g = xe(this.baseHash, n.hash), A = "", R = 0; R < m; R++) {
        var x = this.rules[R];
        if (typeof x == "string")
          A += x, process.env.NODE_ENV !== "production" && (g = xe(g, x + R));
        else if (x) {
          var y = Fe(x, r, t, n), o = Array.isArray(y) ? y.join("") : y;
          g = xe(g, o + R), A += o;
        }
      }
      if (A) {
        var v = St(g >>> 0);
        if (!t.hasNameForId(i, v)) {
          var N = n(A, "." + v, void 0, i);
          t.insertRules(i, v, N);
        }
        s.push(v);
      }
    }
    return s.join(" ");
  }, e;
}(), Vn = /^\s*\/\/.*$/gm, Bn = [":", "[", ".", "#"];
function Hn(e) {
  var r, t, n, i, s = e === void 0 ? Ce : e, c = s.options, u = c === void 0 ? Ce : c, f = s.plugins, m = f === void 0 ? rt : f, g = new ln(u), A = [], R = function(o) {
    function v(N) {
      if (N)
        try {
          o(N + "}");
        } catch {
        }
    }
    return function(N, _, P, T, d, H, se, q, K, le) {
      switch (N) {
        case 1:
          if (K === 0 && _.charCodeAt(0) === 64)
            return o(_ + ";"), "";
          break;
        case 2:
          if (q === 0)
            return _ + "/*|*/";
          break;
        case 3:
          switch (q) {
            case 102:
            case 112:
              return o(P[0] + _), "";
            default:
              return _ + (le === 0 ? "/*|*/" : "");
          }
        case -2:
          _.split("/*|*/}").forEach(v);
      }
    };
  }(function(o) {
    A.push(o);
  }), x = function(o, v, N) {
    return v === 0 && Bn.indexOf(N[t.length]) !== -1 || N.match(i) ? o : "." + r;
  };
  function y(o, v, N, _) {
    _ === void 0 && (_ = "&");
    var P = o.replace(Vn, ""), T = v && N ? N + " " + v + " { " + P + " }" : P;
    return r = _, t = v, n = new RegExp("\\" + t + "\\b", "g"), i = new RegExp("(\\" + t + "\\b){2,}"), g(N || !v ? "" : v, T);
  }
  return g.use([].concat(m, [function(o, v, N) {
    o === 2 && N.length && N[0].lastIndexOf(t) > 0 && (N[0] = N[0].replace(n, x));
  }, R, function(o) {
    if (o === -2) {
      var v = A;
      return A = [], v;
    }
  }])), y.hash = m.length ? m.reduce(function(o, v) {
    return v.name || ze(15), xe(o, v.name);
  }, 5381).toString() : "", y;
}
var dr = ot.createContext();
dr.Consumer;
var ur = ot.createContext(), Kn = (ur.Consumer, new cr()), Et = Hn();
function Wn() {
  return me(dr) || Kn;
}
function Xn() {
  return me(ur) || Et;
}
var qn = function() {
  function e(r, t) {
    var n = this;
    this.inject = function(i, s) {
      s === void 0 && (s = Et);
      var c = n.name + s.hash;
      i.hasNameForId(n.id, c) || i.insertRules(n.id, c, s(n.rules, c, "@keyframes"));
    }, this.toString = function() {
      return ze(12, String(n.name));
    }, this.name = r, this.id = "sc-keyframes-" + r, this.rules = t;
  }
  return e.prototype.getName = function(r) {
    return r === void 0 && (r = Et), this.name + r.hash;
  }, e;
}(), Qn = /([A-Z])/, Zn = /([A-Z])/g, Jn = /^ms-/, eo = function(e) {
  return "-" + e.toLowerCase();
};
function Ht(e) {
  return Qn.test(e) ? e.replace(Zn, eo).replace(Jn, "-ms-") : e;
}
var Kt = function(e) {
  return e == null || e === !1 || e === "";
};
function Fe(e, r, t, n) {
  if (Array.isArray(e)) {
    for (var i, s = [], c = 0, u = e.length; c < u; c += 1)
      (i = Fe(e[c], r, t, n)) !== "" && (Array.isArray(i) ? s.push.apply(s, i) : s.push(i));
    return s;
  }
  if (Kt(e))
    return "";
  if (Pt(e))
    return "." + e.styledComponentId;
  if (He(e)) {
    if (typeof (m = e) != "function" || m.prototype && m.prototype.isReactComponent || !r)
      return e;
    var f = e(r);
    return process.env.NODE_ENV !== "production" && _t.isElement(f) && console.warn(yt(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), Fe(f, r, t, n);
  }
  var m;
  return e instanceof qn ? t ? (e.inject(t, n), e.getName(n)) : e : gt(e) ? function g(A, R) {
    var x, y, o = [];
    for (var v in A)
      A.hasOwnProperty(v) && !Kt(A[v]) && (Array.isArray(A[v]) && A[v].isCss || He(A[v]) ? o.push(Ht(v) + ":", A[v], ";") : gt(A[v]) ? o.push.apply(o, g(A[v], v)) : o.push(Ht(v) + ": " + (x = v, (y = A[v]) == null || typeof y == "boolean" || y === "" ? "" : typeof y != "number" || y === 0 || x in dn ? String(y).trim() : y + "px") + ";"));
    return R ? [R + " {"].concat(o, ["}"]) : o;
  }(e) : e.toString();
}
var Wt = function(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function to(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  return He(e) || gt(e) ? Wt(Fe(Gt(rt, [e].concat(t)))) : t.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : Wt(Fe(Gt(e, t)));
}
var Xt = /invalid hook call/i, qe = /* @__PURE__ */ new Set(), ro = function(e, r) {
  if (process.env.NODE_ENV !== "production") {
    var t = "The component " + e + (r ? ' with the id of "' + r + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, n = console.error;
    try {
      var i = !0;
      console.error = function(s) {
        if (Xt.test(s))
          i = !1, qe.delete(t);
        else {
          for (var c = arguments.length, u = new Array(c > 1 ? c - 1 : 0), f = 1; f < c; f++)
            u[f - 1] = arguments[f];
          n.apply(void 0, [s].concat(u));
        }
      }, Ar(), i && !qe.has(t) && (console.warn(t), qe.add(t));
    } catch (s) {
      Xt.test(s.message) && qe.delete(t);
    } finally {
      console.error = n;
    }
  }
}, no = function(e, r, t) {
  return t === void 0 && (t = Ce), e.theme !== t.theme && e.theme || r || t.theme;
}, oo = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, ao = /(^-|-$)/g;
function ut(e) {
  return e.replace(oo, "-").replace(ao, "");
}
var io = function(e) {
  return St(lr(e) >>> 0);
};
function Qe(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var vt = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, so = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function co(e, r, t) {
  var n = e[t];
  vt(r) && vt(n) ? pr(n, r) : e[t] = r;
}
function pr(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  for (var i = 0, s = t; i < s.length; i++) {
    var c = s[i];
    if (vt(c))
      for (var u in c)
        so(u) && co(e, c[u], u);
  }
  return e;
}
var fr = ot.createContext();
fr.Consumer;
var pt = {};
function mr(e, r, t) {
  var n = Pt(e), i = !Qe(e), s = r.attrs, c = s === void 0 ? rt : s, u = r.componentId, f = u === void 0 ? function(_, P) {
    var T = typeof _ != "string" ? "sc" : ut(_);
    pt[T] = (pt[T] || 0) + 1;
    var d = T + "-" + io("5.3.3" + T + pt[T]);
    return P ? P + "-" + d : d;
  }(r.displayName, r.parentComponentId) : u, m = r.displayName, g = m === void 0 ? function(_) {
    return Qe(_) ? "styled." + _ : "Styled(" + yt(_) + ")";
  }(e) : m, A = r.displayName && r.componentId ? ut(r.displayName) + "-" + r.componentId : r.componentId || f, R = n && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, x = r.shouldForwardProp;
  n && e.shouldForwardProp && (x = r.shouldForwardProp ? function(_, P, T) {
    return e.shouldForwardProp(_, P, T) && r.shouldForwardProp(_, P, T);
  } : e.shouldForwardProp);
  var y, o = new Gn(t, A, n ? e.componentStyle : void 0), v = o.isStatic && c.length === 0, N = function(_, P) {
    return function(T, d, H, se) {
      var q = T.attrs, K = T.componentStyle, le = T.defaultProps, ae = T.foldedComponentIds, te = T.shouldForwardProp, ne = T.styledComponentId, ce = T.target;
      process.env.NODE_ENV !== "production" && Ot(ne);
      var J = function(w, a, D) {
        w === void 0 && (w = Ce);
        var p = ge({}, a, { theme: w }), z = {};
        return D.forEach(function(M) {
          var I, l, j, B = M;
          for (I in He(B) && (B = B(p)), B)
            p[I] = z[I] = I === "className" ? (l = z[I], j = B[I], l && j ? l + " " + j : l || j) : B[I];
        }), [p, z];
      }(no(d, me(fr), le) || Ce, d, q), be = J[0], ie = J[1], re = function(w, a, D, p) {
        var z = Wn(), M = Xn(), I = a ? w.generateAndInjectStyles(Ce, z, M) : w.generateAndInjectStyles(D, z, M);
        return process.env.NODE_ENV !== "production" && Ot(I), process.env.NODE_ENV !== "production" && !a && p && p(I), I;
      }(K, se, be, process.env.NODE_ENV !== "production" ? T.warnTooManyClasses : void 0), we = H, he = ie.$as || d.$as || ie.as || d.as || ce, Pe = Qe(he), E = ie !== d ? ge({}, d, {}, ie) : d, h = {};
      for (var S in E)
        S[0] !== "$" && S !== "as" && (S === "forwardedAs" ? h.as = E[S] : (te ? te(S, $t, he) : !Pe || $t(S)) && (h[S] = E[S]));
      return d.style && ie.style !== d.style && (h.style = ge({}, d.style, {}, ie.style)), h.className = Array.prototype.concat(ae, ne, re !== ne ? re : null, d.className, ie.className).filter(Boolean).join(" "), h.ref = we, Tr(he, h);
    }(y, _, P, v);
  };
  return N.displayName = g, (y = ot.forwardRef(N)).attrs = R, y.componentStyle = o, y.displayName = g, y.shouldForwardProp = x, y.foldedComponentIds = n ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : rt, y.styledComponentId = A, y.target = n ? e.target : e, y.withComponent = function(_) {
    var P = r.componentId, T = function(H, se) {
      if (H == null)
        return {};
      var q, K, le = {}, ae = Object.keys(H);
      for (K = 0; K < ae.length; K++)
        q = ae[K], se.indexOf(q) >= 0 || (le[q] = H[q]);
      return le;
    }(r, ["componentId"]), d = P && P + "-" + (Qe(_) ? _ : ut(yt(_)));
    return mr(_, ge({}, T, { attrs: R, componentId: d }), t);
  }, Object.defineProperty(y, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(_) {
    this._foldedDefaultProps = n ? pr({}, e.defaultProps, _) : _;
  } }), process.env.NODE_ENV !== "production" && (ro(g, A), y.warnTooManyClasses = function(_, P) {
    var T = {}, d = !1;
    return function(H) {
      if (!d && (T[H] = !0, Object.keys(T).length >= 200)) {
        var se = P ? ' with the id of "' + P + '"' : "";
        console.warn("Over 200 classes were generated for component " + _ + se + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), d = !0, T = {};
      }
    };
  }(g, A)), y.toString = function() {
    return "." + y.styledComponentId;
  }, i && Rn(y, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), y;
}
var Ct = function(e) {
  return function r(t, n, i) {
    if (i === void 0 && (i = Ce), !_t.isValidElementType(n))
      return ze(1, String(n));
    var s = function() {
      return t(n, i, to.apply(void 0, arguments));
    };
    return s.withConfig = function(c) {
      return r(t, n, ge({}, i, {}, c));
    }, s.attrs = function(c) {
      return r(t, n, ge({}, i, { attrs: Array.prototype.concat(i.attrs, c).filter(Boolean) }));
    }, s;
  }(mr, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  Ct[e] = Ct(e);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const V = Ct, lo = V.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  padding: 152px 132px ${fe.xxlarge}px;
  @media ${Re.lessThanSmall} {
    padding: 112px ${fe.base}px ${fe.xxlarge}px;
  }
`, uo = V.img``, po = V.p`
  font-weight: ${Ie.bold};
  margin-top: ${fe.xlarge}px;
  font-size: ${ye.medium}px;
  text-align: center;
  line-height: 28px;
  margin: ${fe.large}px 0;
  width: 504px;
  @media ${Re.lessThanSmall} {
    width: 343px;
  }
`, fo = V(Tt)`
  font-weight: ${Ie.regular};
  font-size: ${ye.root}px;
  text-align: center;
  width: 504px;
  line-height: 24px;
  @media ${Re.lessThanSmall} {
    width: 343px;
  }
`, hr = () => {
  const e = it(), { assets: r } = e.hosts, { t } = Se($e), { triggerAnalyticsEvent: n } = at();
  return Be(() => {
    n({
      pageKind: W.CUSTOM_CARD,
      pageFunction: Y.CUSTOM_CARD,
      pageSubFunction: ue.STATUSES,
      pageName: X.TECHNICAL_ERROR,
      messageType: ke.API_FAILURE,
      errorMessage: Le.TECHNICAL_ERROR
    });
  }, []), /* @__PURE__ */ oe(lo, { children: [
    /* @__PURE__ */ C(uo, { alt: "", src: `${r}${Jr}` }),
    /* @__PURE__ */ C(po, { "data-cy": "technical-error-title", children: /* @__PURE__ */ C(
      It,
      {
        i18nKey: "headings.technicalErrorTitle",
        ns: $e,
        t
      }
    ) }),
    /* @__PURE__ */ C(fo, { "data-cy": "technical-error-description", children: /* @__PURE__ */ C(It, { i18nKey: "labels.tryAgainText" }) })
  ] });
};
class gr extends Rr {
  constructor(r) {
    super(r), this.state = {
      hasError: !1,
      error: null
    };
  }
  static getDerivedStateFromError(r) {
    return { hasError: !0, error: r };
  }
  componentDidCatch(r, t) {
    this.setState({ error: r }), console.error("Uncaught error:", r, t);
  }
  render() {
    const { hasError: r, error: t } = this.state, { children: n } = this.props;
    return r && t ? /* @__PURE__ */ C(hr, {}) : n;
  }
}
gr.contextType = De;
const Ze = {
  CARD_PRINTING_INPROGRESS: "CARD_PRINTING_INPROGRESS",
  CARD_SENT: "CARD_SENT",
  PENDING: "PENDING",
  REJECTED: "REJECTED"
}, st = (e, r) => {
  const t = me(Rt), n = er();
  if (!t)
    throw new Error("No config");
  return {
    config: t,
    queryOptions: {
      ...n.getQueryDefaults(),
      enabled: e,
      ...r
    }
  };
}, Me = (e = !0) => {
  const { selectedAccountId: r } = me(De), t = st(e);
  return kr({
    keyProps: {
      accountId: r,
      /**
       * AccountIdType is needed in order to convert them to usable account numbers
       * APIs internally support "guid|account as string" and needs us to explicitly pass in the type
       * since account numbers we get are encoded as guid from the accounts api
       */
      accountIdType: "guid"
    },
    ...t
  });
}, yr = (e = !0) => {
  const { selectedAccountId: r } = me(De), t = st(e);
  return Or({
    keyProps: {
      accountId: r,
      /**
       * AccountIdType is needed in order to convert them to usable account numbers
       * APIs internally support "guid|account as string" and needs us to explicitly pass in the type
       * since account numbers we get are encoded as guid from the accounts api
       */
      accountIdType: "guid"
    },
    ...t
  });
}, mo = (e = !0) => {
  const { selectedAccountId: r } = me(De), t = st(e);
  return Lr({
    keyProps: {
      accountId: r,
      /**
       * AccountIdType is needed in order to convert them to usable account numbers
       * APIs internally support "guid|account as string" and needs us to explicitly pass in the type
       * since account numbers we get are encoded as guid from the accounts api
       */
      accountIdType: "guid"
    },
    ...t
  });
}, ho = (e = !0) => {
  const { selectedAccountId: r } = me(De), t = st(e);
  return $r({
    keyProps: {
      accountId: r,
      /**
       * AccountIdType is needed in order to convert them to usable account numbers
       * APIs internally support "guid|account as string" and needs us to explicitly pass in the type
       * since account numbers we get are encoded as guid from the accounts api
       */
      accountIdType: "guid"
    },
    ...t
  });
}, go = V.div`
  position: absolute;
  width: 100%;
  bottom: 0;
`, Ye = (e) => /* @__PURE__ */ C(go, { children: /* @__PURE__ */ C(Ur, { dataCy: "drawer-footer", ...e }, "footer") }), yo = V.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  padding: 152px 132px ${fe.xxlarge}px;
  @media ${Re.lessThanSmall} {
    padding: 112px ${fe.base}px ${fe.xxlarge}px;
  }
`, So = V.div`
  display: block;
`, Eo = V.img`
  margin: 0 auto;
`, vo = V.p`
  font-weight: ${Ie.bold};
  margin-top: ${ye.xxLarge}px;
  font-size: ${ye.medium}px;
  text-align: center;
  margin: ${fe.large}px 0;
  max-width: 504px;
`, qt = V(Tt)`
  font-weight: ${Ie.regular};
  font-size: ${ye.root}px;
  text-align: center;
  max-width: 504px;
`, ct = ({
  screenVerbiageDefinitions: e,
  imagePath: r,
  portfolioName: t
}) => {
  const n = it(), { assets: i } = n.hosts;
  return /* @__PURE__ */ oe(yo, { children: [
    /* @__PURE__ */ C(Eo, { alt: "", src: `${i}${r}` }),
    /* @__PURE__ */ C(vo, { "data-cy": "screen-title", children: pe.t(e.screenTitle, {
      portfolioName: t
    }) }),
    /* @__PURE__ */ oe(So, { children: [
      /* @__PURE__ */ C(qt, { "data-cy": "screen-primary-description", children: pe.t(e.screenPrimaryDescription, {
        portfolioName: t
      }) }),
      /* @__PURE__ */ C(et, {}),
      /* @__PURE__ */ C(qt, { "data-cy": "screen-secondary-description", children: pe.t(e.screenSecondaryDescription, {
        portfolioName: t
      }) })
    ] })
  ] });
}, Co = {
  screenTitle: "screen.cardPrintingInProgress.title",
  screenPrimaryDescription: "screen.cardPrintingInProgress.primaryDescriptionText",
  screenSecondaryDescription: "screen.common.secondaryDescriptionText"
}, Ao = () => {
  const { data: e } = Me(), { t: r } = Se(), { handleModalClose: t } = _e(), n = {
    dataCy: "drawer-footer",
    dataType: Y.CUSTOM_CARD,
    handlePrimaryButton: t,
    primaryText: r("button.closeButtonText"),
    dataPrimaryReason: Ke,
    dataPrimaryObject: Ae
  };
  return e ? /* @__PURE__ */ oe(Te, { children: [
    /* @__PURE__ */ C(
      ct,
      {
        imagePath: or,
        portfolioName: e.product.portfolio,
        screenVerbiageDefinitions: Co
      }
    ),
    /* @__PURE__ */ C(Ye, { ...n })
  ] }) : null;
}, To = {
  screenTitle: "screen.cardSent.title",
  screenPrimaryDescription: "screen.cardSent.primaryDescriptionText",
  screenSecondaryDescription: "screen.common.secondaryDescriptionText"
}, Ro = () => {
  const { data: e } = Me(), { t: r } = Se(), { handleModalClose: t } = _e(), n = {
    dataCy: "drawer-footer",
    dataType: Y.CUSTOM_CARD,
    handlePrimaryButton: t,
    primaryText: r("button.closeButtonText"),
    dataPrimaryReason: Ke,
    dataPrimaryObject: Ae
  };
  return e ? /* @__PURE__ */ oe(Te, { children: [
    /* @__PURE__ */ C(
      ct,
      {
        imagePath: or,
        portfolioName: e.product.portfolio,
        screenVerbiageDefinitions: To
      }
    ),
    /* @__PURE__ */ C(Ye, { ...n })
  ] }) : null;
}, Qt = () => {
  const { t: e } = Se(), { handleModalClose: r } = _e(), t = {
    dataCy: "drawer-footer",
    dataType: Y.CUSTOM_CARD,
    handlePrimaryButton: r,
    primaryText: e("button.closeButtonText"),
    dataPrimaryReason: Ke,
    dataPrimaryObject: Ae
  };
  return /* @__PURE__ */ oe(Te, { children: [
    /* @__PURE__ */ C(hr, {}),
    /* @__PURE__ */ C(Ye, { ...t })
  ] });
};
function _o(e) {
  if (e) {
    if (e.product.type === "DUAL_CARD")
      return nn;
    if (e.product.type === "PRIVATE_LABEL")
      return on;
  }
  return "";
}
const ft = "customCardArtAction", Sr = () => ({
  setSessionAction: (n) => {
    sessionStorage.setItem(ft, n);
  },
  getSessionAction: () => sessionStorage.getItem(ft),
  removeSessionAction: () => {
    sessionStorage.removeItem(ft);
  }
}), Er = V.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`, bo = V(Er)`
  background: radial-gradient(#00a98f, #008479);
  height: 490px;
  padding: 24px 0;
  position: relative;
  text-align: center;
  width: 100%;
  @media ${Re.lessThanSmall} {
    height: 278px;
  }
`, wo = V.p`
  font-weight: ${Ie.bold};
  font-size: ${ye.xLarge}px;
  text-align: center;
  color: ${tr.white};
  line-height: ${Dt.large};
  margin: auto;
  max-width: 504px;
  width: 100%;
  white-space: break-spaces;
  position: absolute;
  @media ${Re.lessThanSmall} {
    font-size: ${ye.medium}px;
    line-height: ${Dt.root};
    max-width: 247px;
  }
`, Po = V.img`
  margin: 0 auto;
  position: absolute;
  bottom: 0px;
  width: 100%;
  max-width: 365px;
  height: 308px;
  @media ${Re.lessThanSmall} {
    max-width: 246px;
    height: 156px;
  }
`, xo = V.img`
  margin: 0 auto;
  position: absolute;
  bottom: 20px;
  width: 100%;
  max-width: 504px;
  height: 318px;
  @media ${Re.lessThanSmall} {
    bottom: 9px;
    max-width: 247px;
    height: 156px;
  }
`, Oo = V.div`
  display: block;
  padding: 16px;
`;
V.img`
  margin: 0 auto;
`;
const Je = V(Tt)`
  font-weight: ${Ie.regular};
  font-size: ${ye.root}px;
  max-width: 504px;
  white-space: pre-line;
`, No = ({
  screenVerbiageDefinitions: e,
  innerFrameImagePath: r,
  frameImagePath: t,
  portfolioName: n
}) => {
  const i = it(), { assets: s } = i.hosts;
  return /* @__PURE__ */ oe(Er, { children: [
    /* @__PURE__ */ oe(bo, { children: [
      /* @__PURE__ */ C(wo, { "data-cy": "screen-title", children: pe.t(e.screenTitle, {
        portfolioName: n
      }) }),
      /* @__PURE__ */ C(Po, { src: `${s}${r}` }),
      /* @__PURE__ */ C(xo, { src: `${s}${t}` })
    ] }),
    /* @__PURE__ */ oe(Oo, { "data-cy": "screen-getStarted-description", children: [
      /* @__PURE__ */ C(Je, { "data-cy": "screen-offering-description", children: pe.t(e.screenOfferingDescription, {
        portfolioName: n
      }) }),
      /* @__PURE__ */ C(et, {}),
      /* @__PURE__ */ C(Je, { "data-cy": "screen-process-description", children: pe.t(e.screenProcessDescription, {
        portfolioName: n
      }) }),
      /* @__PURE__ */ C(et, {}),
      /* @__PURE__ */ C(Je, { "data-cy": "screen-extraNote-description", children: pe.t(e.screenExtraNoteDescription, {
        portfolioName: n
      }) }),
      /* @__PURE__ */ C(et, {}),
      /* @__PURE__ */ C(Je, { "data-cy": "screen-customizeNow-description", children: pe.t(e.screenCustomizeNowDescription, {
        portfolioName: n
      }) })
    ] })
  ] });
}, Io = {
  screenTitle: "screen.getStarted.title",
  screenOfferingDescription: "screen.getStarted.offeringDescription",
  screenProcessDescription: "screen.getStarted.processDescription",
  screenExtraNoteDescription: "screen.getStarted.extraNoteDescription",
  screenCustomizeNowDescription: "screen.getStarted.customizeNowDescription"
}, Do = () => {
  const { data: e } = Me(), { t: r } = Se(), {
    handleModalClose: t,
    transition: n,
    reset: i
  } = _e(), { authenticationRedirect: s } = at(), { setSessionAction: c } = Sr(), { error: u, isFetching: f } = mo(), g = {
    dataCy: "getStarted-drawer-footer",
    handlePrimaryButton: async () => {
      u?.response?.status === 403 && (c("stepUp"), i(), s()), u || n("manageCardArt");
    },
    isPrimaryLoading: f,
    primaryText: r("button.getStarted"),
    dataPrimaryObject: Ae,
    dataPrimaryReason: Gr,
    secondaryText: r("button.cancelButtonText"),
    dataSecondaryObject: Ae,
    dataSecondaryReason: jr,
    handleSecondaryButton: t,
    secondaryButtonType: "ghost"
  };
  return e ? /* @__PURE__ */ oe(Te, { children: [
    /* @__PURE__ */ C(
      No,
      {
        frameImagePath: _o(e),
        innerFrameImagePath: rn,
        portfolioName: e.product.portfolio,
        screenVerbiageDefinitions: Io
      }
    ),
    /* @__PURE__ */ C(Ye, { ...g })
  ] }) : null;
}, Mo = {
  en: "en-US",
  es: "es-ES"
}, Oe = {
  COMPLETE: "complete",
  COMPLETE_CLOSE: "complete-close",
  ERROR: "error",
  EXIT_SUCCESS: "exit success",
  RESET_IMAGE: "reset image"
}, ko = [
  Oe.COMPLETE,
  Oe.COMPLETE_CLOSE,
  Oe.ERROR,
  Oe.EXIT_SUCCESS,
  Oe.RESET_IMAGE
], Lo = {
  exit: {
    errorMessage: Le.EXIT_CONFIRMATION,
    message: Ne.LOSE_ALL_PROGRESS,
    messageType: ke.EXIT_CONFIRMATION,
    pageFunction: Y.CUSTOM_CARD,
    pageKind: W.CUSTOM_CARD,
    pageSubFunction: ue.EXIT,
    pageName: X.CONFIRMATION
  },
  editor: {
    pageFunction: Y.CUSTOM_CARD,
    pageKind: W.CUSTOM_CARD,
    pageSubFunction: "",
    pageName: X.EDITOR
  },
  instructions: {
    pageFunction: Y.CUSTOM_CARD,
    pageKind: W.CUSTOM_CARD,
    pageSubFunction: ue.GUIDELINE,
    pageName: X.VIEW
  },
  "image coverage error": {
    message: Ne.IMAGE_FILL_CONTAINER,
    pageFunction: Y.CUSTOM_CARD,
    pageKind: W.CUSTOM_CARD,
    pageName: X.EDITOR
  },
  preview: {
    pageFunction: Y.CUSTOM_CARD,
    pageKind: W.CUSTOM_CARD,
    pageSubFunction: ue.PLACE_ORDER,
    pageName: X.PREVIEW
  },
  reset: {
    errorMessage: Le.IMAGE_RESET_CONFIRMATION,
    message: Ne.CHANGES_UNDONE,
    messageType: ke.IMAGE_RESET_CONFIRMATION,
    pageFunction: Y.CUSTOM_CARD,
    pageKind: W.CUSTOM_CARD,
    pageSubFunction: ue.RESET,
    pageName: X.CONFIRMATION
  },
  start: {
    pageFunction: Y.CUSTOM_CARD,
    pageKind: W.CUSTOM_CARD,
    pageSubFunction: ue.INSTRUCTIONS,
    pageName: X.START
  },
  "error maxSize": {
    ErrorMessage: Le.IMAGE_TOO_LARGE,
    MessageType: ke.VALIDATION_FAILURE,
    PageFunction: Y.CUSTOM_CARD,
    PageKind: W.CUSTOM_CARD,
    pageName: X.ERROR
  },
  "error minSize": {
    ErrorMessage: Le.IMAGE_TOO_SMALL,
    MessageType: ke.VALIDATION_FAILURE,
    PageFunction: Y.CUSTOM_CARD,
    PageKind: W.CUSTOM_CARD,
    pageName: X.ERROR
  },
  "error notSupported": {
    ErrorMessage: Le.FILE_FORMAT_NOT_SUPPORTED,
    MessageType: ke.VALIDATION_FAILURE,
    PageFunction: Y.CUSTOM_CARD,
    PageKind: W.CUSTOM_CARD,
    pageName: X.ERROR
  }
}, $o = async (e) => {
  const r = await fetch(e);
  if (!r.ok)
    throw new Fr(r);
  return await r.json();
}, Uo = (e) => Pr(
  ["thalesEnvServiceFileData", e],
  () => $o(e)
), Fo = V.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${fe.xxlarge}px;
`, zo = V.span`
  margin-top: ${fe.large}px;
  font-size: ${ye.medium}px;
  font-weight: ${Ie.bold};
  line-height: 1.4;
  color: ${tr.black};
`, vr = (e) => {
  const { loadingText: r } = e;
  return /* @__PURE__ */ oe(Fo, { children: [
    /* @__PURE__ */ C(zr, { size: 7 }),
    /* @__PURE__ */ C(zo, { "data-cy": "loader-text", children: r })
  ] });
}, Yo = V.div`
  height: '100vh';
  img {
    display: inline;
  }
`;
let ve;
const jo = () => {
  const { lang: e, hosts: r } = it(), { serviceFile: t } = r, { envProp: n, triggerAnalyticsEvent: i } = at(), { transition: s, handleModalClose: c } = _e(), [u, f] = Nt(!0), [m, g] = Nt(!1), { t: A } = Se(), { data: R, isFetching: x } = Uo(`${t}`), { data: y } = yr(), { data: o } = Me(), { data: v } = ho(), N = o?.product.type, _ = v?.profile?.["cipher.email"], P = () => R ? n === "production" ? {
    scriptURL: R.production.scriptURL,
    styleSheetURL: R.production.styleSheetURL,
    designerEnvironmentOption: R.production.designerEnvironmentOption,
    handoverKey: R.production.handoverKey
  } : {
    scriptURL: R.development.scriptURL,
    styleSheetURL: R.development.styleSheetURL,
    designerEnvironmentOption: R.development.designerEnvironmentOption,
    handoverKey: R.development.handoverKey
  } : {
    scriptURL: "",
    styleSheetURL: "",
    designerEnvironmentOption: "",
    handoverKey: {
      DUAL_CARD: "",
      PRIVATE_LABEL: ""
    }
  }, { handoverKey: T, scriptURL: d, styleSheetURL: H, designerEnvironmentOption: se } = P(), q = _r(() => {
    ve = document.createElement("script"), ve.async = !0, ve.src = d, document.body.appendChild(ve);
    const K = document.createElement("link");
    K.href = H, K.rel = "stylesheet", document.body.appendChild(K), ve.onload = () => {
      f(!1), i({
        pageKind: W.CUSTOM_CARD,
        pageFunction: Y.CUSTOM_CARD,
        pageSubFunction: ue.STATUSES,
        pageName: X.START
      });
    }, ve.onerror = () => {
      g(!0), s("error");
    };
  }, [R]);
  return Be(() => {
    if (!u && !m) {
      const K = window.aam;
      new K.designer({
        callbacks: {
          onSubmit: () => {
            i({
              message: Ne.SENT_FOR_APPROVAL,
              pageFunction: Y.CUSTOM_CARD,
              pageKind: W.CUSTOM_CARD,
              pageName: X.COMPLETE
            });
          },
          onViewChange: (ae) => {
            (ae === Oe.EXIT_SUCCESS || ae === Oe.COMPLETE_CLOSE) && c(), !ko.includes(ae) && i(Lo[ae]);
          }
        },
        options: {
          detectMobile: !0,
          env: se,
          emailAddress: _,
          handback: {
            enabled: !1
          },
          languageId: Mo[e],
          passthrough: {
            obfuscatedAccountId: y?.uniqueAccountId
          }
        }
      }).start();
    }
  }, [u, m, e]), Be(() => (x || q(), () => {
    ve && document.body.removeChild(ve);
  }), [x, q]), /* @__PURE__ */ C(Te, { children: x ? /* @__PURE__ */ C(vr, { loadingText: A("labels.customCardArtLoaderText") }) : /* @__PURE__ */ C(
    Yo,
    {
      className: "my-container",
      "data-cy": "designer-container",
      id: "designerContainer",
      children: /* @__PURE__ */ C(
        "div",
        {
          className: "aam-designer-init",
          "data-handoverkey": T[N],
          id: "aam-designer"
        }
      )
    }
  ) });
}, Go = () => /* @__PURE__ */ C(jo, {}), Vo = {
  screenTitle: "screen.pending.title",
  screenPrimaryDescription: "screen.pending.primaryDescriptionText",
  screenSecondaryDescription: "screen.common.secondaryDescriptionText"
}, Bo = () => {
  const { data: e } = Me(), { t: r } = Se(), { handleModalClose: t } = _e(), n = {
    dataCy: "drawer-footer",
    dataType: Y.CUSTOM_CARD,
    handlePrimaryButton: t,
    primaryText: r("button.closeButtonText"),
    dataPrimaryReason: Ke,
    dataPrimaryObject: Ae
  };
  return e ? /* @__PURE__ */ oe(Te, { children: [
    /* @__PURE__ */ C(
      ct,
      {
        imagePath: tn,
        portfolioName: e.product.portfolio,
        screenVerbiageDefinitions: Vo
      }
    ),
    /* @__PURE__ */ C(Ye, { ...n })
  ] }) : null;
}, Ho = {
  screenTitle: "screen.rejected.title",
  screenPrimaryDescription: "screen.rejected.primaryDescriptionText",
  screenSecondaryDescription: "screen.common.secondaryDescriptionText"
}, Ko = () => {
  const { data: e } = Me(), { t: r } = Se(), { handleModalClose: t, transition: n } = _e(), i = () => {
    n("getStarted");
  }, s = {
    dataCy: "rejected-drawer-footer",
    dataType: Y.CUSTOM_CARD,
    handlePrimaryButton: i,
    primaryText: r("button.uploadNewImage"),
    dataPrimaryReason: Br,
    dataPrimaryObject: Ae,
    secondaryText: r("button.closeButtonText"),
    handleSecondaryButton: t,
    secondaryButtonType: "ghost",
    dataSecondaryReason: Ke,
    dataSecondaryObject: Ae
  };
  return e ? /* @__PURE__ */ oe(Te, { children: [
    /* @__PURE__ */ C(
      ct,
      {
        imagePath: en,
        portfolioName: e.product.portfolio,
        screenVerbiageDefinitions: Ho
      }
    ),
    /* @__PURE__ */ C(Ye, { ...s })
  ] }) : null;
}, Wo = (e) => {
  const r = {
    [Ze.PENDING]: "pending",
    [Ze.REJECTED]: "rejected",
    [Ze.CARD_PRINTING_INPROGRESS]: "cardPrintingInProgress",
    [Ze.CARD_SENT]: "cardSent"
  };
  return e && r[e] ? r[e] : "getStarted";
}, Xo = (e) => {
  const r = {
    getStarted: Do,
    pending: Bo,
    cardPrintingInProgress: Ao,
    cardSent: Ro,
    manageCardArt: Go,
    rejected: Ko,
    error: Qt
  };
  return e in r ? r[e] : Qt;
}, Zt = "otpErrorCallbackParams", qo = () => ({ getStepUpError: () => sessionStorage.getItem(Zt), removeStepUpError: () => {
  sessionStorage.removeItem(Zt);
} }), Qo = ({
  containerId: e,
  selectedAccountId: r
}) => {
  const { t } = Se($e), { activeScreen: n, handleModalClose: i, isModalOpen: s, transition: c, reset: u } = _e(), { getSessionAction: f, removeSessionAction: m } = Sr(), { getStepUpError: g, removeStepUpError: A } = qo(), { data: R } = Me(), {
    data: x,
    isFetching: y,
    isError: o
  } = yr();
  Be(() => {
    const _ = x?.status;
    if (s && !y) {
      if (o || _ === void 0) {
        c("error");
        return;
      }
      const P = f();
      m();
      const T = g();
      if (A(), P === "stepUp" && !T) {
        c("manageCardArt");
        return;
      }
      const d = Wo(_);
      c(d);
    }
    return () => {
      u();
    };
  }, [x?.status, y, s]);
  const v = n === "manageCardArt", N = n && Xo(n);
  return /* @__PURE__ */ C(
    Dr,
    {
      ariaLabel: t("title.drawerTitle", {
        portfolioName: R?.product.portfolio
      }),
      containerId: e,
      "data-cy": "custom-card-art-modal",
      escapeModalHandler: v ? () => null : i,
      header: v ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        /* @__PURE__ */ C(Te, {})
      ) : /* @__PURE__ */ C(
        Mr,
        {
          closeButtonAriaLabel: "Close Dialog",
          closeModal: i,
          content: t("title.drawerTitle", {
            portfolioName: R?.product.portfolio
          }),
          "data-cy": "custom-card-art-drawer-name",
          dataReason: Vr,
          dataType: Y.CUSTOM_CARD
        }
      ),
      id: `custom-card-art-modal-${r}`,
      isOpen: s,
      children: N && /* @__PURE__ */ C(N, {}) || /* @__PURE__ */ C(
        vr,
        {
          loadingText: t("labels.customCardArtLoaderText")
        },
        "screen"
      )
    }
  );
}, ha = ({
  closeModal: e,
  containerId: r,
  envProp: t,
  isModalOpen: n,
  mfeConfig: i,
  selectedAccountId: s,
  triggerAnalyticsEvent: c,
  authenticationRedirect: u
}) => {
  Be(() => {
    pe.changeLanguage(i.lang);
  }, [i.lang]);
  const f = Jt(
    () => ({
      envProp: t,
      selectedAccountId: s,
      triggerAnalyticsEvent: c,
      authenticationRedirect: u
    }),
    [t, s, c, u]
  );
  return /* @__PURE__ */ C(wr, { i18n: pe, children: /* @__PURE__ */ C(De.Provider, { value: f, children: /* @__PURE__ */ C(gr, { children: /* @__PURE__ */ C(Xr, { value: i, children: /* @__PURE__ */ oe(
    Wr,
    {
      handleModalClose: e,
      isModalOpen: n,
      children: [
        /* @__PURE__ */ C(
          "input",
          {
            id: "Custom_Card_Art_build_version",
            type: "hidden",
            value: Yr.BuildVersion
          }
        ),
        /* @__PURE__ */ C(
          Qo,
          {
            containerId: r,
            selectedAccountId: s
          }
        )
      ]
    }
  ) }) }) }) });
};
export {
  ha as default
};
//# sourceMappingURL=index.js.map
